var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
import NavigationService from "@ane/core/lib/services/NavigationService";
import { ROUTES } from "./Routes.constants.js";
class Util {
  constructor() {
    __publicField(this, "_modulePath", ROUTES.computeManagementSystem.root.match.path);
    __publicField(this, "_modulePathname", ROUTES.computeManagementSystem.root.location.pathname);
    __publicField(this, "routes", {
      root: {
        path: () => `${this.path}`,
        getURL: () => `${this.url}`
      },
      list: {
        path: () => `${this.path}`,
        getURL: () => {
          return `${this.url}`;
        }
      },
      register: {
        path: () => `${this.path}${ROUTES.computeManagementSystem.create.match.path}`,
        getURL: () => {
          return `${this.url}${ROUTES.computeManagementSystem.create.match.path}`;
        }
      },
      view: {
        path: () => `${this.path}${ROUTES.computeManagementSystem.view.match.path}`,
        getURL: (payload) => {
          const { id } = payload;
          return `${this.url}/${id}`;
        }
      }
    });
  }
  /**
   * React Router regex path
   */
  get path() {
    return `${NavigationService.root.path}${this._modulePath}`;
  }
  /**
   * Pathname used to construct complete URL
   */
  get url() {
    return `${NavigationService.root.url}${this._modulePathname}`;
  }
}
const ComputeRouteUtils = new Util();
export {
  ComputeRouteUtils
};
//# sourceMappingURL=ComputeRoute.utils.js.map
